import { Box, Button, DialogContent, Typography } from '@mui/material';
import SuccessIcon from 'app/components/Icons/SuccessIcon';
import CustomDialog from 'app/components/ui/Dialog/Dialog';
import { useTranslation } from 'react-i18next';

interface SuccessDialogProps {
  open: boolean;
  edit?: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
  label: string;
}

const ConfirmationDialog = ({ open, handleClose, label, handleSubmit }: SuccessDialogProps) => {
  const { t } = useTranslation();

  return (
    <CustomDialog
      hideBackdrop={true}
      maxWidth='sm'
      closeIcon={false}
      open={open}
      handleClose={handleClose}
    >
      <DialogContent
        sx={{
          display: 'flex',
          width: '516px',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '56px !important',
          gap: '16px',
        }}
      >
        <SuccessIcon />
        <Typography sx={{ fontSize: '24px', fontWeight: 600, textAlign: 'center' }}>
          {label}
        </Typography>
        <Box display='flex' gap={2}>
          <Button onClick={handleSubmit}>{t('commonActions.goToHomePage')}</Button>
          <Button color='secondary' onClick={handleClose}>
            {t('commonActions.close')}
          </Button>
        </Box>
      </DialogContent>
    </CustomDialog>
  );
};

export default ConfirmationDialog;
